/**
 * @param s string to capitalize
 * @returns capitalized string
 */
export function capitalize(s) {
    return `${s[0].toUpperCase()}${s.slice(1)}`;
}
